// extracted by mini-css-extract-plugin
export default {"cash_fund_preferences":"CashFundPreferencesDrawer-style__cash_fund_preferences__BgWBv"};